export default __webpack_public_path__ + "static/media/up-next-light.78d6f325.png";